import { render } from "./NavigationPanel.vue?vue&type=template&id=49be2fc1&scoped=true"
import script from "./NavigationPanel.vue?vue&type=script&lang=js"
export * from "./NavigationPanel.vue?vue&type=script&lang=js"

import "./NavigationPanel.vue?vue&type=style&index=0&id=49be2fc1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49be2fc1"]])

export default __exports__